import { Component } from 'react';
import Footer from '../../Footer';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import ComplianceCarrossel from '../../ComplianceCarrossel';
import DocumentLink from '../../DocumentLink';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import Lgpd from '../../Lgpd';
import InfoComponent from '../InfoComponent';

class ProgramaCompliance extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"programa-de-compliance"} page={'programa-de-compliance'}></InfoComponent>

					{/* Content page */}
					<div className="_the-content page-planos pb-2">
						<div className='container'>
							<div className="row justify-content-center">
								<div className="col-md-10">
									<div className="row">
										<ErrorBoundary><DocumentLink fileImg={'../../assets/img/Regulamentos_Prancheta 1.png'} url={'ObterDocumentosCompliance'} /></ErrorBoundary>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div>
						<ErrorBoundary><ComplianceCarrossel /></ErrorBoundary>
					</div>

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default ProgramaCompliance;